import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=b3bdda88&scoped=true"
import script from "./CardForm.vue?vue&type=script&lang=js"
export * from "./CardForm.vue?vue&type=script&lang=js"
import style0 from "./CardForm.vue?vue&type=style&index=0&id=b3bdda88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bdda88",
  null
  
)

export default component.exports